import { MeasurementUtility } from '@inter-ikea-kompis/utilities/lib';
import { mmToCm } from './measurementUtils';
import { IStorageOneTranslations } from 'contexts/serviceSettings';

export const adjustMeasurementsSystem = (
  millimeter: number,
  translations: IStorageOneTranslations,
  useMetricMeasures?: boolean,
  roundToNbrOfDecimals: number = 0
): string => {
  if (useMetricMeasures)
    return mmToCm(millimeter, roundToNbrOfDecimals === 0).toFixed(roundToNbrOfDecimals);
  let roundedMm;
  if (roundToNbrOfDecimals === 0) {
    roundedMm = Math.round(millimeter / 10) * 10;
  } else {
    roundedMm = Math.round(millimeter);
  }
  return MeasurementUtility.metricToImperial(translations.kompis, roundedMm, false, true); // remove unit
};

export const adjustMeasurementsSystemSummary = (millimeter: number): number => {
  const roundedMm = Math.round(millimeter / 10) * 10;
  return roundedMm;
};
